<div class="dev-bar">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="col-auto d-flex align-items-center">
                <nb-icon icon="hash-outline" class="mr-2"></nb-icon>
                <span>ambiente de desenvolvimento</span>
                <hr class="divider vertical" />
            </div>
            <div class="col-8 col-lg-5">
                <div class="host-selector">
                    <span>Host selecionado: {{ host }}</span>
                    <button nbButton size="tiny" status="primary" (click)="openHostDialog()" class="ml-2">
                        <nb-icon icon="settings-outline" class="mr-1"></nb-icon>
                        Mudar host
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
